// Latin letters covering Latin 9 ISO-8859-15 (-00FF), Latin Extended-A (0100-017F) and Latin Extended-B (018F-021F)
const latinLetters =
  'a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u017F\\u018F\\u0192\\u01B7\\u01DE-\\u01EF\\u01FA-\\u01FF\\u0218\\u0219\\u021A\\u021B\\u021E\\u021F'

export const regExps: Record<string, string> = {
  isPersonName: '^[\\u0020\\u0027\\u002D\\.' + latinLetters + ']*$', // space (20), apostrophe (27), hyphen-minus (2D) and latin letters
  // isIbanValue: '^[a-zA-Z]{2}([0-9]\\s?){16,18}$',
  // isIbanValueEU:
  //   '^[a-zA-Z]{2}[0-9]{2}\\s?[a-zA-Z0-9]{4}\\s?[0-9\\s]{7,8}([a-zA-Z0-9\\s]?){0,20}$', // eslint-disable-line max-len
  // isBicValue: '^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$',
  isPhoneNumberValue:
    '^(([(][+]?[0-9]{1,3}[)])?[ ]?|[+])?[0-9]{0,3}[-]?[0-9 ]+$|^$'
  // isPercentageValue: '^[0-9]{0,2}([,.][0-9]{0,2})?$',
  // isSalaryValue: '^[0-9]{0,6}([,.][0-9]{0,2})?$',
  // isChildCountValue: '^[0-9]{0,2}$',
  // isFileNameValid: '^[ -~äöåÄÖÅ]*$', // permissable characters are ASCII 32-126 and äöå,
  // isSSNumberValid: '^[0-9]{6}(\\+|-|A)[0-9]{3}([0-9]|[A-F,H-N,P,R-Y])$'
}

export const getValidationRegExp = (name: string, flags = 'g') => {
  return new RegExp(regExps[name], flags)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRequired = (name: string, yupSchema: any) => {
  const fieldNames = name.split('.') || []
  if (fieldNames.length === 0) return false
  let current = yupSchema.describe() || null
  return fieldNames.some((fieldName) => {
    current = current.fields[fieldName] || null
    if (current) {
      if (
        Array.isArray(current.tests) &&
        current.tests.length > 0 &&
        current.tests.some((test: { name: string }) => test.name === 'required')
      ) {
        return true
      }
    }
    return false
  })
}
